import { CAMPOS_DESTINO, CAMPOS_PRODUTO } from '@/pages/painel/lib/whatsappImport';

interface Props {
  headers: string[];
  mapping: Record<string, string>;
  onChange: (key: string, value: string) => void;
}

export default function ColunaMapper({ headers, mapping, onChange }: Props) {
  const Selector = ({ campoKey, label, obrigatorio, hint }: { campoKey: string; label: string; obrigatorio?: boolean; hint?: string }) => (
    <div>
      <label className="flex items-center gap-1 text-[11px] font-semibold text-gray-600">
        {label}
        {obrigatorio && <span className="text-[#E8610A]">*</span>}
      </label>
      <select
        value={mapping[campoKey] ?? ''}
        onChange={(e) => onChange(campoKey, e.target.value)}
        className={`mt-1 w-full border rounded-lg px-2.5 py-1.5 text-sm bg-white cursor-pointer focus:outline-none focus:border-[#E8610A] ${
          mapping[campoKey] ? 'border-gray-200 text-gray-800' : 'border-gray-200 text-gray-400'
        }`}
      >
        <option value="">— não mapear —</option>
        {headers.map((h) => <option key={h} value={h}>{h}</option>)}
      </select>
      {hint && <p className="text-[10px] text-gray-400 mt-0.5 leading-snug">{hint}</p>}
    </div>
  );

  return (
    <div className="space-y-5">
      <div>
        <p className="text-xs font-semibold text-gray-600 uppercase tracking-wider mb-3">Campos principais</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {CAMPOS_DESTINO.map((c) => (
            <Selector key={c.key} campoKey={c.key} label={c.label} obrigatorio={c.obrigatorio} hint={c.hint} />
          ))}
        </div>
      </div>

      <div>
        <p className="text-xs font-semibold text-gray-600 uppercase tracking-wider mb-1">Produtos / Soluções (intensidade de menções)</p>
        <p className="text-[11px] text-gray-400 mb-3">O número representa sinais encontrados no histórico, não quantidade comprada.</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {CAMPOS_PRODUTO.map((c) => (
            <Selector key={c.key} campoKey={c.key} label={c.label} />
          ))}
        </div>
      </div>
    </div>
  );
}